<template>
  <div class="card mb-3">
    <div class="card-body bg-secondary pb-0">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="input-wrapper">
            <input-widget :model="searchModel"
                          attribute="action"
                          type="select2"
                          :items="actionsToSearch"
                          value-field="key"
                          :label="false"
                          display-field="${item.text}"
                          :options="{placeholder: $t('Action')}"/>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import ActivitySearch from "@/modules/activities/ActivitySearch.model";

  const {mapActions} = createNamespacedHelpers('activities');

  export default {
    name: "ActivitySearch",
    components: {InputWidget},
    props: {
      actionsToSearch: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        searchModel: new ActivitySearch()
      }
    },
    methods: {
      ...mapActions(['getActivities', 'updateSearchModel', 'resetPaginationPage']),
      async onSearch() {
        this.resetPaginationPage();
        await this.updateSearchModel(this.searchModel);
        await this.getActivities();
      },
      async onResetClick() {
        this.searchModel = new ActivitySearch();
        await this.onSearch();
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
